import { useSearchPageShouldShowEscapeHatchText } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageShouldShowEscapeHatchText";
import { SearchPageSpellCheckEscapeHatch } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSpellCheckEscapeHatch/SearchPageSpellCheckEscapeHatch";
import { useSearchPageSpellCorrectedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";
import { useSearchPageRequestId } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SubHeader } from "@faire/retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackSearchSpellcheckqueryviewView } from "@faire/web-api--source/events/search/view/spellcheckqueryview";
import React from "react";

export const MaybeSearchPageSpellCheckSubheader = () => {
  const shouldShowEscapeHatchText = useSearchPageShouldShowEscapeHatchText();
  const searchString = useSearchPageProductSearchString();
  const requestId = useSearchPageRequestId();
  const spellCorrectedQuery = useSearchPageSpellCorrectedQuery();
  const ref = useDoActionWhenVisible(() =>
    trackSearchSpellcheckqueryviewView(
      spellCorrectedQuery ?? "",
      searchString,
      requestId ?? ""
    )
  );

  return shouldShowEscapeHatchText ? (
    <SubHeader data-test-id="spell-check-escape-hatch" ref={ref}>
      <SearchPageSpellCheckEscapeHatch />
    </SubHeader>
  ) : null;
};
